import React from "react";
import { styled, alpha, useTheme } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import AppIcon from "ui/components/icons/AppIcon";
import { iconSearch } from "ui/components/icons";
import GlobalSearch from "ui/partials/global-search/GlobalSearch";
import { ShortcutTag } from "ui/components/data-display/ShortcutTag";
import { useGlobalSearchContext } from "./SearchProvider";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover, &:focus-within": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  width: "100%",
  maxWidth: "14em",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  height: "32px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(0.5, 1.5),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
  },
}));

const SearchInput = () => {
  const theme = useTheme();
  const { handleOpen } = useGlobalSearchContext();

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      handleOpen();
    }
  };

  return (
    <>
      <Search
        style={{ display: "flex" }}
        onClick={handleOpen}
        onKeyDown={handleKeyDown}
        data-test-id="gs-open-modal"
      >
        <SearchIconWrapper>
          <AppIcon icon={iconSearch} />
        </SearchIconWrapper>
        <StyledInputBase
          id="globalSearchInput"
          placeholder="Search"
          readOnly
          inputProps={{ "aria-label": "Global Search" }}
        />
        <ShortcutTag
          testId="gs-input-shortcut-tag"
          shortcut="K"
          onShortcutDown={handleOpen}
          bgColor={alpha(theme.palette.common.white, 0.15)}
        />
      </Search>

      <GlobalSearch />
    </>
  );
};

export default SearchInput;
